import React, { useState } from "react";

import { message, Spin } from "antd";

import Header from "../../components/Header";
import "./styles.scss";
import { saveAxiosBlobAs } from "../../helpers/saveAxiosBlobAs";
import { exportarRelatorioAtividadesRecentes } from "../../services/http/atividadeRecenteService";
import lang from "../../assets/idioma/idiomas";

const Log = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    data: null,
    mes: null,
    ano: null,
  });

  const excelRelatorioAtividadesRecentes = async () => {
    if (data.mes && !data.ano) {
      message.error("Insira um ano para prosseguir.");
      return;
    }

    const response = await exportarRelatorioAtividadesRecentes(
      data.ano,
      data.mes,
      data.data
    );
    saveAxiosBlobAs(response);
  };
  return (
    <Spin spinning={loading}>
      <Header style={{ marginBottom: "2rem" }} />
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="div-galeria-opcoes">
              <span className="titulo-listagem">
                {lang.Log_de_movimentacao}
              </span>
              <div> </div>
            </div>
            <div className="row">
              <hr className="linha" />
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-3 ">
                <label>{lang.Data_alteracao}:</label>
                <input
                  className="input-log"
                  type="date"
                  onChange={(e) => {
                    const value = e.target.value;
                    const formattedValue = value.slice(0, 10);
                    setData((prev) => ({ ...prev, data: formattedValue }));
                  }}
                  value={data.data}
                />
              </div>
              <div className="col-md-2 col-sm-2 ">
                <label>{lang.Mes}:</label>
                <select
                  className="input-log"
                  onChange={(e) =>
                    setData((prev) => ({ ...prev, mes: e.target.value }))
                  }
                  value={data.mes}
                >
                  <option value="">{lang.Selecionar}</option>
                  <option value="1">{lang.Janeiro}</option>
                  <option value="2">{lang.Fevereiro}</option>
                  <option value="3">{lang.Marco}</option>
                  <option value="4">{lang.Abril}</option>
                  <option value="5">{lang.Maio}</option>
                  <option value="6">{lang.Junho}</option>
                  <option value="7">{lang.Julho}</option>
                  <option value="8">{lang.Agosto}</option>
                  <option value="9">{lang.Setembro}</option>
                  <option value="10">{lang.Outubro}</option>
                  <option value="11">{lang.Novembro}</option>
                  <option value="12">{lang.Dezembro}</option>
                </select>
              </div>
              <div className="col-md-2 col-sm-2  ">
                <label>{lang.Ano}:</label>
                <select
                  className="input-log"
                  value={data.ano}
                  onChange={(e) =>
                    setData((prev) => ({ ...prev, ano: e.target.value }))
                  }
                >
                  <option value="">{lang.Selecionar}</option>
                  {Array.from(
                    { length: new Date().getFullYear() - 2021 + 1 },
                    (_, i) => 2021 + i
                  )
                    .reverse()
                    .map((ano) => (
                      <option key={ano} value={ano}>
                        {ano}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-3 col-sm-3">
                <button
                  className="gerarRelatorio"
                  onClick={() => excelRelatorioAtividadesRecentes()}
                >
                  {lang.Gerar_Relatorio}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Log;
